module.exports = __webpack_public_path__ + "static/media/muji-cd-player-naoto-fukusawa.5e8293f9.png";